module.exports = __webpack_public_path__ + "static/media/rs.09794fa5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/flags/rs.png
// module id = 1968
// module chunks = 0